var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { cx } from "@emotion/css";
import { color } from "styled-system";
import { styled } from "../theme";
var getFontSize = function (size) {
    switch (size) {
        case "sm":
            return 10;
        case "md":
        case "base":
            return 20;
        case "lg":
            return 30;
        default:
            return size;
    }
};
export var Icon = function (_a) {
    var name = _a.name, size = _a.size, color = _a.color, className = _a.className, props = __rest(_a, ["name", "size", "color", "className"]);
    return (React.createElement(I, __assign({ className: cx("icon", "icon-" + name, className), color: color, size: size }, props)));
};
var I = styled.i(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: inherit;\n  font-size: ", "px;\n  ", "\n"], ["\n  color: inherit;\n  font-size: ", "px;\n  ", "\n"])), function (_a) {
    var size = _a.size;
    return getFontSize(size);
}, color);
Icon.defaultProps = {
    size: "base",
};
var templateObject_1;
